// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31K7W","placeholdersHeader":"styles_placeholdersHeader__3k6aZ","editorStyle":"styles_editorStyle__1dmfD","placeholdersBox":"styles_placeholdersBox__3tiQ2"};